import * as React from 'react';
import * as _ from 'lodash';
import { Grid } from '@material-ui/core';
import { ButtonStyle, EMPTY_TEXT, FileInputCaptureEnum, getFileIconByType, Magnetic, Modal, Select, Twisty } from '@mitchell/react.component.ux';
import { BrandedNotification, WARNING_TEMPLATE_MODAL_SAVE_BUTTON_ID, WARNING_TEMPLATE_MODAL_STAY_HERE_BUTTON_ID } from "../../brandedNotification";
import { EnterpriseDocStoreService, MimeTypeService, TranslationService } from "../../common";
import { ConnectedFileInput } from "../../file";
import { getPRGImageByDescription, photoCaptureAllowedMimeType, getPRGPanelParentImages, isPrgCompanyCode, getFileDescriptionByAttributeType, getFolderModelInfo } from '../utilities';
import { IntelligentPhotoCaptureViewType, PhotoCapture, PhotoCaptureAttributeType } from '../enums';
import { CONFIRMATION_MODAL_TITLE, DAMAGE_PANEL, FILE_INPUT_ICON_SIZE, MIC_PROGRESSIVE_CONSTANT, PhotoCaptureAllowedMimeTypeConstant, PhotoCaptureConstants, PhotoCaptureScriptQuestionIds } from '../constants';
import { StyledThumbnail, StyledPanelContainerGrid, StyledPanelLabel, StyledAdditionalPanelLabel, StyledDivInlineView, StyledUploadButton, StyledDivImage, StyledDivImageButton, StyleDamagePanelLabelGrid, StyledEditIcon, StyledAddMorePanelContainerGrid, StyledDeleteIcon, StyledClearPanelLabel, StyledBorderPanel, StyledAddMoreLabel, StyledDamageGroupOptionWrapper, TemplateContainerGridWrapper, ContentSectionGridWrapper } from './PhotoCaptureDamagePanelComponent.style';
export const PhotoCaptureDamagePanelComponent = ({ twistyLabel, twistyIndex, buttonBackgroundColor, onFileUploadedSuccess, imageMaxWidth, companyCode, fileSizeLimit, imageData, disableLibrary, maxChildDamagePanelCount, setImageData, setIsImageUpdated, questionSubType, isClearButtonVisible = true, isDeleteButtonVisible = false, setSelectedImage, onViewChange, folderOptionList, language = PhotoCaptureConstants.EN_US, onMicPRGMiscDetails, isMic }) => {
    const translate = TranslationService.translate;
    const [fileDescriptionTag, setFileDescriptionTag] = React.useState(EMPTY_TEXT);
    const hasWideEnhancedSubType = questionSubType !== PhotoCaptureAttributeType.WIDE_ENHANCED;
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isDamagePanelUpdated, setIsDamagePanelUpdated] = React.useState(true);
    const [damageParentImageData, setDamageParentImageData] = React.useState(getPRGPanelParentImages(imageData));
    const [folderListData, setFolderListData] = React.useState([]);
    const [selectOptionList, setSelectOptionList] = React.useState([]);
    const [currentTaskContent, setCurrentTaskContent] = React.useState({
        identifier: 0,
        id: 0,
        isUpdated: false,
        taskName: EMPTY_TEXT
    });
    const [damagePanel, setDamagePanel] = React.useState([
        {
            id: 0,
            damageId: EMPTY_TEXT,
            damageName: EMPTY_TEXT,
            isExpanded: true
        }
    ]);
    const onFileInputClick = ({ damageName, id, additionalImageTag, isParentImage, fileMetadataDesc, damageId, parentIdentifier }) => {
        const { Parent, Child } = MIC_PROGRESSIVE_CONSTANT;
        if (id && additionalImageTag && onViewChange) {
            const filterData = imageData &&
                imageData.find(item => item.thumbnailDocUId === id && item.additionalImageTag === additionalImageTag);
            if (filterData) {
                onMicPRGMiscDetails({
                    damageName,
                    isParentImage,
                    additionalImageTag,
                    fileDescription: fileMetadataDesc,
                    damageId,
                    parentIdentifier
                });
                setSelectedImage && setSelectedImage(filterData);
                onViewChange(IntelligentPhotoCaptureViewType.COMMENT, (filterData.isParentImage && Parent) || Child);
            }
        }
        else if (isMic && onViewChange) {
            onMicPRGMiscDetails({
                damageName,
                isParentImage,
                additionalImageTag,
                fileDescription: fileMetadataDesc,
                damageId: damageId,
                parentIdentifier
            });
            onViewChange(IntelligentPhotoCaptureViewType.CAMERA, (isParentImage && Parent) || Child);
            setFileDescriptionTag(damageName);
        }
        else {
            setFileDescriptionTag(damageName);
        }
    };
    React.useEffect(() => {
        if (imageData.length) {
            setDamageParentImageData(getPRGPanelParentImages(imageData));
        }
        else {
            setDamageParentImageData([]);
        }
    }, [imageData]);
    React.useEffect(() => {
        if (imageData && imageData.length && isDamagePanelUpdated) {
            const validImages = imageData.filter(image => {
                const underscoreCount = image.additionalImageTag
                    ? (image.additionalImageTag.match(/_/g) || []).length
                    : 0;
                return underscoreCount === 1;
            });
            // Map valid images to the damage panel structure
            const updatedDamagePanel = validImages.map(image => {
                // Split the additionalImageTag and get the second part
                const idFromTagString = image.additionalImageTag && image.additionalImageTag.split('_')[1];
                // Convert it to a number and check if it's a valid number
                const idFromTag = (idFromTagString && Number(idFromTagString)) || 0;
                return {
                    id: idFromTag,
                    damageId: image.damageId || EMPTY_TEXT,
                    damageName: image.damageName || EMPTY_TEXT,
                    isExpanded: true // Set the default expansion state
                };
            });
            setDamagePanel(updatedDamagePanel);
        }
    }, [imageData, isDamagePanelUpdated]);
    React.useEffect(() => {
        if (folderOptionList && folderOptionList.length) {
            const defaultFolderList = {
                folderTypeId: PhotoCaptureConstants.DEFAULT_FOLDER_TYPE_ID,
                folderTypeCode: EMPTY_TEXT,
                folderTypeDesc: EMPTY_TEXT,
                isActive: true,
                folderAlias: [
                    {
                        language: PhotoCaptureConstants.EN_US,
                        folderDesc: PhotoCaptureConstants.SELECT
                    },
                    {
                        language: PhotoCaptureConstants.FR_CA,
                        folderDesc: PhotoCaptureConstants.SELECT_FR
                    }
                ]
            };
            setFolderListData([defaultFolderList, ...folderOptionList]);
        }
    }, [folderOptionList]);
    const elementRenderWrapper = (imageDescription, imageContent, elementType, isDisabled, damageName, isParentImage, fileMetadataDesc, damageId, parentIdentifier) => {
        if (elementType === PhotoCaptureScriptQuestionIds.ID_DAMAGE_PANEL_BUTTON_PARENT) {
            return imageContent && imageContent.thumbnailDocUId ? (React.createElement(StyledDivImage, { id: imageDescription, src: EnterpriseDocStoreService.createFileUrl(imageContent.thumbnailDocUId), onClick: () => onFileInputClick({
                    isParentImage: isParentImage,
                    damageName,
                    id: imageContent.thumbnailDocUId,
                    additionalImageTag: imageContent.additionalImageTag,
                    fileMetadataDesc,
                    damageId,
                    parentIdentifier
                }) })) : (React.createElement(StyledDivImageButton, { id: imageDescription, backgroundColor: buttonBackgroundColor, className: PhotoCaptureConstants.ICON_CLASS, onClick: () => onFileInputClick({
                    damageName,
                    isParentImage,
                    additionalImageTag: imageDescription,
                    fileMetadataDesc,
                    damageId,
                    parentIdentifier
                }), value: imageDescription }));
        }
        else {
            return imageContent && imageContent.thumbnailDocUId ? (React.createElement(StyledDivInlineView, { id: imageDescription, key: imageContent.thumbnailDocUId, onClick: () => onFileInputClick({
                    isParentImage: isParentImage,
                    damageName,
                    id: imageContent.thumbnailDocUId,
                    additionalImageTag: imageContent.additionalImageTag,
                    fileMetadataDesc,
                    damageId,
                    parentIdentifier
                }) },
                React.createElement(StyledThumbnail, { id: imageContent.attachmentIdentifier, url: EnterpriseDocStoreService.createFileUrl(imageContent.thumbnailDocUId), height: '68px', width: '68px', defaultIcon: getFileIconByType(MimeTypeService.lookup(imageContent.fileName)) }))) : (React.createElement(StyledUploadButton, { disabled: isDisabled, isDisabled: isDisabled, icon: PhotoCaptureConstants.ICON_ATTACHMENT_CLASS, style: ButtonStyle.FlatCompact, iconSize: FILE_INPUT_ICON_SIZE, id: imageDescription, onClick: () => onFileInputClick({
                    damageName,
                    isParentImage,
                    additionalImageTag: imageDescription,
                    fileMetadataDesc,
                    damageId,
                    parentIdentifier
                }) }));
        }
    };
    const getIsElementDisabled = (imageContent, isDisabled) => isMic || isDisabled || !!(imageContent && imageContent.thumbnailDocUId);
    /**
     * Damage Panel function to render dynamic number of file input component which belongs to its parent individual
     * @param maxChildDamagePanelCount as number to create that number of panel
     * @returns
     */
    const damagePanelFileInputComponent = ({ fileInputAppendedId, imageDescription, imageContent, damagePanelType, isParentImage, damageName, isDisabled = false, damageId, parentIdentifier }) => {
        const fileMetadataDesc = getFileDescriptionByAttributeType(questionSubType, isParentImage);
        let connectedFileInputProps = Object.assign({ applicationName: PhotoCaptureConstants.PHOTO_CAPTURE_APPLICATION_NAME, companyCode: companyCode, acceptedMimeTypes: photoCaptureAllowedMimeType, disabled: getIsElementDisabled(imageContent, isDisabled), element: elementRenderWrapper(imageDescription, imageContent, damagePanelType, isDisabled, damageName, isParentImage, fileMetadataDesc, damageId, parentIdentifier), isDuplicateDocumentAllowed: false, scaledMaxSize: imageMaxWidth, thumbnailMaxSize: PhotoCaptureConstants.THUMBNAIL_MAX_SIZE, multiple: false, onAllFileUploadComplete: files => onFileUploadedSuccess(files, fileDescriptionTag, isParentImage, imageDescription, fileMetadataDesc, damageId), id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_${fileInputAppendedId}`, allowedFileTypes: PhotoCaptureAllowedMimeTypeConstant, maxFileSize: fileSizeLimit }, (isPrgCompanyCode(companyCode) && { fileDescription: fileMetadataDesc }));
        disableLibrary === PhotoCaptureConstants.Y &&
            (connectedFileInputProps = Object.assign(Object.assign({}, connectedFileInputProps), { acceptedMimeTypes: PhotoCaptureConstants.ACCEPT_IMAGE_MIME, captureMode: FileInputCaptureEnum.ENVIRONMENT }));
        return React.createElement(ConnectedFileInput, Object.assign({}, connectedFileInputProps, { key: imageDescription }));
    };
    /**
     * Damage Panel function to render dynamic number of file input component which belongs to its parent individual
     * @param maxChildDamagePanelCount as number to create that number of panel
     * @returns
     */
    const damagePanelChildComponent = ({ maxChildDamagePanelCount, panelItem, isDisabled, parentIdentifier }) => {
        return (React.createElement(React.Fragment, null, _.map(_.range(maxChildDamagePanelCount), (item, index) => damagePanelFileInputComponent({
            fileInputAppendedId: `${PhotoCaptureScriptQuestionIds.ID_DAMAGE_PANEL_BUTTON_CHILD}_${panelItem.id}_${index}`,
            imageDescription: `${DAMAGE_PANEL.DAMAGE}_${panelItem.id}_Image_${index}`,
            imageContent: getPRGImageByDescription(`${DAMAGE_PANEL.DAMAGE}_${panelItem.id}_Image_${index}`, imageData),
            damagePanelType: PhotoCaptureScriptQuestionIds.ID_DAMAGE_PANEL_BUTTON_CHILD,
            isDisabled: isDisabled,
            damageName: panelItem.damageName,
            isParentImage: false,
            damageId: panelItem.damageId,
            parentIdentifier: parentIdentifier
        }))));
    };
    /**
     * Damage Panel function to render dynamic number of parent panel individual
     * @param damagePanelList as IPhotocaptureObject to create that number of panel list
     * @returns
     */
    const damagePanelParentComponent = ({ damagePanelList }) => {
        // *****************
        // tab Close/Open when this handleSelectChange run
        // Error Message when selected DamageName is deleted from the DropDown
        // ***************
        const handleWrapperClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
        const handleSelectChange = (event, id) => {
            const latestDamageName = event.label !== translate(PhotoCaptureConstants.SELECT) ? event.label : EMPTY_TEXT;
            const latestDamageId = event.value !== '0' ? event.value : EMPTY_TEXT;
            setDamagePanel(prevState => {
                return prevState.map(panel => panel.id === id ? Object.assign(Object.assign({}, panel), { damageId: latestDamageId, damageName: latestDamageName }) : panel);
            });
            if (imageData.length) {
                if (setImageData) {
                    const updatedImageData = imageData.map(data => {
                        const imageDataIndex = data.additionalImageTag && data.additionalImageTag.split('_')[1];
                        if (Number(imageDataIndex !== null && imageDataIndex !== void 0 ? imageDataIndex : -1) !== id) {
                            return data;
                        }
                        // If imageDataIndex matches the index, update the image data
                        return Object.assign(Object.assign({}, data), { damageId: latestDamageId, damageName: latestDamageName, folderModelInfo: getFolderModelInfo(latestDamageId, folderOptionList) });
                    });
                    setIsDamagePanelUpdated(false);
                    setDamageParentImageData(updatedImageData.filter(item => item.isParentImage === true));
                    setImageData(updatedImageData); // Passing the updated array directly
                    setIsImageUpdated && setIsImageUpdated(true);
                }
            }
        };
        /**
         * Converts folder options to select options with proper language-based labels
         * @param folderOptions - List of folder options to convert
         * @returns Array of select options with appropriate labels based on current language
         */
        const mapFoldersToSelectOptions = (folderOptions) => {
            return folderOptions.reduce((result, folder) => {
                // Find description in current language or fall back to English or EMPTY_TEXT
                const aliasMap = new Map(folder.folderAlias.map(alias => [alias.language, alias.folderDesc]));
                const folderDesc = aliasMap.get(language) || aliasMap.get(PhotoCaptureConstants.EN_US) || EMPTY_TEXT;
                if (folderDesc) {
                    result.push({
                        label: folderDesc,
                        value: folder.folderTypeId
                    });
                }
                return result;
            }, []);
        };
        const filterDamagePanelOptions = (index) => {
            const selectedValues = damagePanel.map(item => item.damageId);
            const filteredOptions = folderListData.filter((option) => !selectedValues.includes(option.folderTypeId) || option.folderTypeId === damagePanel[index].damageId);
            setSelectOptionList(mapFoldersToSelectOptions(filteredOptions));
        };
        const saveButton = {
            id: WARNING_TEMPLATE_MODAL_SAVE_BUTTON_ID,
            isBusy: false,
            label: `${translate(BrandedNotification.CONFIRM)}`,
            onClick: handleModalConfirmationClick
        };
        const stayHereButton = {
            id: WARNING_TEMPLATE_MODAL_STAY_HERE_BUTTON_ID,
            isBusy: false,
            label: `${translate(BrandedNotification.CANCEL)}`,
            onClick: () => openConfirmationPopUp(currentTaskContent)
        };
        return (React.createElement(React.Fragment, null,
            _.map(damagePanelList, (item, index) => {
                const parentImageData = getParentImageData(item.id);
                return (React.createElement(StyledPanelContainerGrid, { direction: "row", wrap: "wrap", container: true, key: index },
                    React.createElement(Twisty, { key: `${twistyLabel}_${twistyIndex}`, defaultExpanded: true, isExpanded: item.isExpanded, onToggle: () => onToggle(item.id), fontSize: Magnetic.fontSize14, label: React.createElement(Grid, { container: true, direction: "row", wrap: "nowrap" },
                            React.createElement(Grid, { item: true, xs: 6, container: true, alignItems: "center" },
                                React.createElement(StyledDamageGroupOptionWrapper, { id: "select-wrapper", onClick: e => handleWrapperClick(e) }, folderOptionList && folderOptionList.length > 0 && (React.createElement(Select, { value: item.damageId ? { label: item.damageName, value: item.damageId } : null, options: selectOptionList, id: `${DAMAGE_PANEL.DAMAGE}-progressive-select`, onChange: event => handleSelectChange(event, item.id), isSearchable: true, placeholder: translate(PhotoCaptureConstants.SELECT), filterOption: { ignoreCase: true, ignoreAccents: true, trim: true, matchFrom: 'start' }, onMenuOpen: () => filterDamagePanelOptions(index) })))),
                            React.createElement(Grid, { item: true, xs: 6, container: true, alignItems: "center", justify: "flex-end" },
                                isClearButtonVisible && (React.createElement(StyledClearPanelLabel, { isPanelMarginEnabled: !(hasWideEnhancedSubType && index), isPanelDisabled: !(parentImageData && parentImageData.parentIdentifier), onClick: event => {
                                        if (!(parentImageData && parentImageData.parentIdentifier)) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            return; // Exit early to prevent execution
                                        }
                                        openConfirmationPopUp({
                                            event,
                                            identifier: parentImageData && parentImageData.parentIdentifier,
                                            id: item.id,
                                            isUpdated: true,
                                            taskName: DAMAGE_PANEL.CLEAR
                                        });
                                    } },
                                    React.createElement("label", null, translate(DAMAGE_PANEL.CLEAR)))),
                                hasWideEnhancedSubType && index ? (React.createElement(React.Fragment, null,
                                    isClearButtonVisible && isDeleteButtonVisible && (React.createElement(StyledBorderPanel, { orientation: "vertical", variant: "middle", flexItem: true })),
                                    isDeleteButtonVisible && (React.createElement(StyledDeleteIcon, { className: DAMAGE_PANEL.ICON_DELETE_CLASS, onClick: event => openConfirmationPopUp({
                                            event,
                                            identifier: parentImageData && parentImageData.parentIdentifier,
                                            id: item.id,
                                            isUpdated: true,
                                            taskName: PhotoCaptureConstants.DELETE
                                        }) })))) : (React.createElement(React.Fragment, null)))) },
                        React.createElement(Grid, { direction: "row", wrap: "wrap", container: true, alignItems: "center" },
                            React.createElement(StyleDamagePanelLabelGrid, { container: true, direction: "row", wrap: "wrap", alignItems: "center" },
                                React.createElement(StyledPanelLabel, { item: true, xs: 2 },
                                    React.createElement("label", null, translate(DAMAGE_PANEL.DAMAGE))),
                                React.createElement(StyledAdditionalPanelLabel, { item: true, xs: 10 },
                                    React.createElement("label", null, translate(DAMAGE_PANEL.ADDITIONAL_PHOTOS)))),
                            React.createElement(Grid, { container: true, direction: "row", wrap: "wrap", alignItems: "center" },
                                damagePanelFileInputComponent({
                                    fileInputAppendedId: `${PhotoCaptureScriptQuestionIds.ID_DAMAGE_PANEL_BUTTON_PARENT}_${item.id}`,
                                    imageDescription: `${DAMAGE_PANEL.DAMAGE}_${item.id}`,
                                    imageContent: parentImageData,
                                    damagePanelType: PhotoCaptureScriptQuestionIds.ID_DAMAGE_PANEL_BUTTON_PARENT,
                                    damageName: item.damageName,
                                    isParentImage: true,
                                    damageId: item.damageId
                                }),
                                damagePanelChildComponent({
                                    maxChildDamagePanelCount,
                                    panelItem: item,
                                    isDisabled: !(parentImageData && parentImageData.parentIdentifier),
                                    parentIdentifier: parentImageData && parentImageData.parentIdentifier
                                }))))));
            }),
            hasWideEnhancedSubType && (React.createElement(StyledAddMorePanelContainerGrid, { direction: "row", wrap: "wrap", container: true, justify: "center" },
                React.createElement(Grid, { item: true },
                    React.createElement(StyledEditIcon, { isButtonDisabled: !getLatestParentDamage(damagePanelList), className: DAMAGE_PANEL.ICON_ADD_MORE_CLASS })),
                React.createElement(Grid, { item: true },
                    React.createElement(StyledAddMoreLabel, { isButtonDisabled: !getLatestParentDamage(damagePanelList), onClick: event => {
                            if (!getLatestParentDamage(damagePanelList)) {
                                event.preventDefault();
                                event.stopPropagation();
                                return; // Exit early to prevent execution
                            }
                            handleAddMoreDamagePanel();
                        }, id: DAMAGE_PANEL.ADD_MORE_PANEL_ID }, translate(DAMAGE_PANEL.ADD_MORE_PANEL))))),
            isModalOpen && (React.createElement(Modal, { isOpen: isModalOpen, title: translate(CONFIRMATION_MODAL_TITLE.HEADING_TITLE), isLightbox: false, maxWidth: "sm", primaryBtn: saveButton, tertiaryBtn: stayHereButton, shouldHideScroll: true, onClose: () => openConfirmationPopUp(currentTaskContent) },
                React.createElement(TemplateContainerGridWrapper, { container: true },
                    React.createElement(ContentSectionGridWrapper, { item: true, xs: 10, className: "confirmation-modal-description" }, translate(CONFIRMATION_MODAL_TITLE.INNER_CONTENT)))))));
    };
    /**
     * Adds a new damage panel to the damage panel list.
     * @returns {void} No return value; it updates the component state.
     */
    const handleAddMoreDamagePanel = () => {
        const newDamagePanelId = damagePanel[damagePanel.length - 1].id + 1;
        setDamagePanel(prev => [
            ...prev,
            {
                id: newDamagePanelId,
                damageId: EMPTY_TEXT,
                damageName: EMPTY_TEXT,
                isExpanded: true
            }
        ]);
    };
    // Modal on confirm function
    const openConfirmationPopUp = (data) => {
        data.event && data.event.stopPropagation();
        setIsModalOpen(prev => !prev);
        setCurrentTaskContent(data);
    };
    const handleModalConfirmationClick = () => {
        setIsDamagePanelUpdated(false);
        if (currentTaskContent.taskName === DAMAGE_PANEL.CLEAR) {
            setImageData &&
                setImageData(imageData.filter((item) => item.additionalImageTag && Number(item.additionalImageTag.split('_')[1]) !== currentTaskContent.id));
            setDamageParentImageData(damageParentImageData.filter((item) => item.additionalImageTag && Number(item.additionalImageTag.split('_')[1]) !== currentTaskContent.id));
            setIsImageUpdated && setIsImageUpdated(true);
        }
        else {
            setImageData &&
                setImageData(imageData.filter((item) => item.additionalImageTag && Number(item.additionalImageTag.split('_')[1]) !== currentTaskContent.id));
            setDamageParentImageData(damageParentImageData.filter((item) => item.additionalImageTag && Number(item.additionalImageTag.split('_')[1]) !== currentTaskContent.id));
            setIsImageUpdated && setIsImageUpdated(true);
            const updateDamagePanel = damagePanel.filter(item => item.id !== currentTaskContent.id);
            setDamagePanel(updateDamagePanel);
        }
        setIsModalOpen(prev => !prev);
    };
    /**
     * Retrieves the latest parent damage identifier.
     * @param damagePanelList as the array of parett image data.
     * @returns {boolean} if parentIdentifier found for the latest parent damage then returns true otherwsie false.
     */
    const getLatestParentDamage = (damagePanelList) => {
        const lastDamageNameId = damagePanelList[damagePanelList.length - 1].id;
        const parentData = getParentImageData(lastDamageNameId);
        return !!(parentData && parentData.parentIdentifier);
    };
    /**
     * Toggles the expanded state of a damage panel.
     * @param itemId as the unique identifier of the damage panel to toggle.
     * @returns {void} No return value; it updates the component state.
     */
    const onToggle = (itemId) => {
        setDamagePanel(prevState => _.map(prevState, item => (item.id === itemId ? Object.assign(Object.assign({}, item), { isExpanded: !item.isExpanded }) : item)));
    };
    /**
     * Retrieves the parent image data for a specific damage panel.
     * @param damageName as the name of the damage panel.
     * @returns {IPhotoCaptureAttachmentFile | undefined} The corresponding image data, if found.
     */
    const getParentImageData = (id) => damageParentImageData.find(item => item.additionalImageTag && Number(item.additionalImageTag.split('_')[1]) === id);
    /**
     * Generates a list of damage list for the given image data, up to specified maximum parent damage count.
     * @returns {IPhotocaptureDamagePanelList[]} A list of damage panels.
     */
    return React.createElement(React.Fragment, null, damagePanel.length && damagePanelParentComponent({ damagePanelList: damagePanel }));
};
//# sourceMappingURL=PhotoCaptureDamagePanelComponent.js.map